import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: "'Open Sans', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        h6: {
            fontSize: '18px',
            fontWeight: 400,
        },
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#023E58',
                    color: 'white',
                    fontSize: '0.875rem',
                },
            },
        },
    },
});

export default theme;
